import fetchFactory from '../../../../utils/fetchFactory'

export const getVisitesList = (passed?: boolean) => {
	return fetchFactory(`/api/ec_residence/visits/getVisitsUtilisateur?${typeof passed === 'boolean' ? `&passed=${passed}` : ''}`)
}